var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSymbolActiveManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9552 12C14.9552 18.0754 13.0767 23 10.7244 23C8.3721 23 6.49364 18.0669 6.49364 12C6.49364 5.93308 8.3721 1 10.7244 1C13.0767 1 14.9552 5.92462 14.9552 12ZM1.23056 17.5C2.38979 19.5054 7.59364 18.6762 12.8567 15.63C18.1198 12.5838 21.4113 8.50538 20.2859 6.5C19.1606 4.49462 13.9229 5.33231 8.65979 8.37C3.39672 11.4077 0.0713326 15.4862 1.23056 17.5ZM20.2859 17.5C21.4113 15.4862 18.1198 11.4077 12.8567 8.37C7.59364 5.33231 2.38979 4.48615 1.23056 6.5C0.0713326 8.51385 3.39672 12.5923 8.65979 15.63C13.9229 18.6677 19.1267 19.5054 20.2859 17.5Z",
    stroke: "#2F6B60",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolActiveManagement);
export default __webpack_public_path__ + "static/media/symbol-active-management.714c6532899119eafa31b4b7db882c42.svg";
export { ForwardRef as ReactComponent };